import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GlobalSearchLocationResult } from '@kempoweroyj/ngx-search-api-client';
import { CeLocationRow } from 'shared/stations-service/locations.service';
import { getAddressLine } from 'shared/utils/getLocationAddressLine';

@Component({
    selector: 'ce-location-badge',
    templateUrl: './location-badge.component.html',
    styleUrls: ['./location-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class LocationBadgeComponent {
    @Input() headerStyle = false;
    @Input() location: CeLocationRow;
    @Input() globalSearchLocation: GlobalSearchLocationResult;

    addressLine = '';

    ngOnChanges() {
        this.addressLine = getAddressLine(this.location);
    }
}
